export default __webpack_public_path__ + "static/media/capaTrilhaNova.3588cfcd.jpg";